<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GrjIHr/tc-custom/9781788634823.jpg?1700807484035" alt="This image is the cover for the book Knockdown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Knockdown
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>New York Times</i>–bestselling</b><b>“master of crime fiction and equine thrills,” a former jockey takes on the crooked world of horse dealing (<i>Newsday).</i></b><br/>  <br/> Dick Francis, Edgar Award–winning master of mystery and suspense, takes you into the thrilling world of horse racing.<br/>  <br/> For a generous commission, ex-prize-winning jockey Jonah Dereham reluctantly agrees to bid on a young steeplechaser on behalf of a wealthy American woman. But his life is thrust into danger immediately following the auction, when he receives a blow to the head by two thugs demanding ownership of the horse. Unfortunately, that’s just the beginning—and now Jonah must figure out the high-stakes game being played . . . before he becomes its next casualty.<br/>  <br/> “Dick Francis is a wonder.” —<i>The Plain Dealer</i><br/><br/> “An imaginative craftsman of high order.” –<i>The Sunday Times</i><br/><br/> “Few things are more convincing than Dick Francis at a full gallop.” —<i>Chicago Tribune</i><br/><br/> “Few match Francis for dangerous flights of fancy and pure inventive menace.” —<i>Boston Herald</i><br/><br/> “[The] master of crime fiction and equine thrills.” <i>—</i><i>Newsday</i><br/><br/> “[Francis] has the uncanny ability to turn out simply plotted yet charmingly addictive mysteries.” –<i>The </i><i>Wall Street Journal</i><br/><br/> “Francis is a genius.” <i>—</i><i>Los Angeles Times</i><br/><br/> “A rare and magical talent . . . who never writes the same story twice.” —<i>The </i><i>San Diego Union-Tribune</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dick Francis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d9af2cee